// extracted by mini-css-extract-plugin
module.exports = {"ArticleMain":"ArticleMain_ArticleMain__h_QbO","ArticleMain__title":"ArticleMain_ArticleMain__title__LcfdT"};